import { ErrorHandler, Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

/**
 * Captura errores no manejados por Angular y los muestra como toast en lugar
 * de tirar la pantalla en blanco. En producción además envía a Sentry/Logger.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly toast = inject(MessageService);

  handleError(error: unknown): void {
    // eslint-disable-next-line no-console
    console.error('[GlobalErrorHandler]', error);

    const message =
      error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : 'Error inesperado';

    this.toast.add({
      severity: 'error',
      summary: 'Algo salió mal',
      detail: message,
      life: 6000,
    });

    // TODO: Sentry.captureException(error) cuando se integre.
  }
}
